// removed by extract-text-webpack-plugin
module.exports = {"dimensions":"_1gGEN_wpeFeN-55akxSPHS","shipping":"_1dd7cFoGk1rjtpnJv6MGMG","buttonEdit":"_25ZeAACOXg-WwT7yiBrKxU","buttonRemove":"XcV_eBYeboGpPmOzOWcEP","buttonOutline":"_1chtvXZIsh6uDHDDnzsvIc"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/OrderEdit/style.scss
// module id = 1065
// module chunks = 0